import { supporters } from "../data/supporters";
import { motion } from "framer-motion";
import HeroSlider from "../Components/HeroSlider";

export default function SupportersPage() {


const heroImages = [
  "./images/image8.jpg",
  "./images/image21.JPG",
  "./images/image24.JPG",
  "./images/image14.jpg",
  "./images/image30.JPG",
  "./images/image32.JPG",
];

  return (
    <><HeroSlider images={heroImages} /><main className="mx-auto max-w-7xl px-4 py-16">
          {/* Hero */}
          <h1 className="mb-14 text-center text-4xl font-bold">Támogatók</h1>

          {/* Grid */}
          <section className="grid gap-12 sm:grid-cols-2 lg:grid-cols-3">
              {supporters.map((s, i) => (
                  <motion.article
                      key={`${s.name}-${i}`}
                      initial={{ opacity: 0, y: 30 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: false }}
                      transition={{ duration: 0.35 }}
                      className="flex flex-col items-center text-center"
                  >
                      {s.logo && s.website && (
                          <a href={s.website} target="_blank" rel="noreferrer" className="mb-4 block">
                              <img
                                  src={s.logo}
                                  alt={s.name}
                                  className="h-32 w-auto object-contain" />
                          </a>
                      )}

                      {s.logo && !s.website && (
                          <img
                              src={s.logo}
                              alt={s.name}
                              className="mb-4 h-32 w-auto object-contain" />
                      )}

                      <h3 className="mb-2 font-semibold">{s.name}</h3>

                      <div className="space-y-1 text-sm text-gray-700">
                          {s.address && <p>{s.address}</p>}
                          {s.phone && <p>Tel.: {s.phone}</p>}
                          {s.email && (
                              <p>
                                  Email:{" "}
                                  <a
                                      href={`mailto:${s.email}`}
                                      className="text-primary underline"
                                  >
                                      {s.email}
                                  </a>
                              </p>
                          )}
                          {s.taxId && <p>Adószám: {s.taxId}</p>}
                          {s.website && (
                              <a
                                  href={s.website}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="text-primary underline"
                              >
                                  {new URL(s.website).hostname}
                              </a>
                          )}
                      </div>
                  </motion.article>
              ))}
          </section>

          {/* 1 % felhívás */}
          <section id="onepercent" className="mt-24 grid gap-10 md:grid-cols-2 md:items-center">
              <div className="space-y-4 text-gray-700 leading-relaxed">
                  <p>
                      Amennyiben támogatni szeretné adója 1 %-val egyesületünk művészeti, értékmegőrző,
                      hagyományőrző munkáját, hozzájárulva ezzel a siófoki néptánc mozgalomkülönböző szintű sikeréhez,
                      a következő elérhetőségen teheti azt meg:
                  </p>

                  <ul className="space-y-1">
                      <li>
                          <span className="font-semibold">Kedvezményezett neve:</span>{" "}
                          <span className="text-primary">Balaton Tánc Egyesület</span>
                      </li>
                      <li>Cím: 8600 Siófok, Szépvölgyi u. 2.</li>
                      <li>Adószám: 19192716-1-14</li>
                      <li>
                          <span className="font-semibold">Számlaszám:</span>{" "}
                          10200531-39672825-00000000
                      </li>
                      <li>
                          Kapcsolat:{" "}
                          <a href="mailto:info@balatonte.hu" className="underline">
                              info@balatonte.hu
                          </a>
                      </li>
                  </ul>
              </div>

              <img
                  src="/supporters/image26.jpg"
                  alt="1% támogatás banner"
                  className="w-full rounded-lg object-cover shadow-md" />
          </section>
      </main></>
  );
}
